import { Observable } from "rxjs";
import { UDXOrderQRData } from "../features/order/order-qr/model/udx-order-qr.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DynamicAttributes, OccEndpointsService, StringTemplate } from "@spartacus/core";
import { Injectable } from "@angular/core";
import { DownloadQRPayload, QRPayloadResponse } from "../features/model";

@Injectable({
    providedIn: 'root',
  })  
export class UDXOrderQRService {
    constructor (
        protected _http: HttpClient,
        protected _occEndpoints: OccEndpointsService,
        ) {}
    fetchTicketDetails(
        orderId: string,
        userId: string,
        pageSize: string = "20",
        currentPage: string = "0",
        sort?: string,
        ticketType?: string,
        qrCodeDownloaded?: string,
        fields: string = "DEFAULT",
    ): Observable<UDXOrderQRData> {
        let paramsObject: DynamicAttributes = {
            queryParams: {
                currentPage,
                fields,
                pageSize,
                sort,
                qrCodeDownloaded,
                orderId,
                ticketType
            },
            urlParams: {
                userId,
            }
        }
        return this._http.get<UDXOrderQRData>(this._occEndpoints.buildUrl('subentriesForQR', paramsObject))
    }
    triggerDownloadForSelectedQR(
        ticketCodes : string[],
        type : string,
        selectedOrderNumber=''): Observable<QRPayloadResponse>
    {
        let payload: DownloadQRPayload = {
            ticketCodes: ticketCodes,
            type: type,
            originalOrderId:selectedOrderNumber
          };
          return this._http.post<QRPayloadResponse>(
          this._occEndpoints.buildUrl('qrDownload'),
          payload,
            httpOptions,
          );
  }
  triggerDownloadForAllQR(
    ticketCodes : string[],
    type : string,
    originalOrderId=''
): Observable<QRPayloadResponse>
{
    let payload: DownloadQRPayload = {
        ticketCodes: ticketCodes,
        type: type,
        originalOrderId: originalOrderId
      };
      console.log(payload)
      return this._http.post<QRPayloadResponse>(
      this._occEndpoints.buildUrl('qrDownload'),
      payload,
      httpOptions);
}
}

const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

const httpOptionsPlainTextResponse = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'text/plain'
    }),
    // responseType: 'text' as const
  };
  